export const environment = {
  production: false,
  api: 'https://dev.api.biilog.com.br/api-v1',
  apiv2: 'https://dev.api.biilog.com.br/api-v2',
  // apiv2: 'http://127.0.0.1:3002/api-v2',
  // api: 'http://127.0.0.1:3000',
};

